import { render, staticRenderFns } from "./UiCountry.vue?vue&type=template&id=b74e99a0&scoped=true&"
import script from "./UiCountry.vue?vue&type=script&lang=js&"
export * from "./UiCountry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b74e99a0",
  null
  
)

export default component.exports